/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DeleteOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Input, message, Tabs } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/return-order/actions'
import {
  formatDateTime,
  getMenuTypeName,
  getReturnOrderStatus,
  numberWithComma,
  toDateQuery,
} from 'helpers/format'
import { menuReturnPaymentTypes, menuReturnStatus, menuReturnChannel, ReturnStatus } from 'helpers/constanst'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import ReturnDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import { RangeDateItem, SelectItem } from 'Components/form'
import theme from 'Components/common/Theme'
import { ConfirmDailog, LoadingView } from 'Components/modal'
import { DeleteReturnReq, ReturnData, ReturnListReq } from 'Store/return-order/types'
import { deleteReturnAPI, returnListAPI } from 'Store/return-order/api'
import { selectReturnActionEvent, selectReturnList, selectReturnListEvent } from 'Store/return-order/selector'
import { StatusTag } from 'Components/utilities'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import Axios from 'axios'
import downloadCSVFile from 'helpers/export'
const { TabPane } = Tabs

type Props = {} & ReduxProps

const OrderReturns: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event } = props
  const dispatch = useDispatch()
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')

  const [filter, setFilter] = useState({
    keyword: '',
    status: '',
    start_date: '',
    end_date: '',
    customer: 0,
    sort: 'desc',
    order_by: 'created_at',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: ReturnListReq = {
      keyword: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      sort: filter.sort || 'desc',
      order_by: filter.order_by || 'created_at',
      status: filter?.status || '',
    }

    dispatch(returnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onDelete = (id: number): void => {
    const req: DeleteReturnReq = {
      id,
    }
    dispatch(deleteReturnAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onExport = (): void => {
    setExporting(true)
    const req: ReturnListReq = {
      keyword: filter.keyword,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      sort: filter.sort || 'desc',
      order_by: filter.order_by || 'created_at',
      status: filter?.status || '',
    }

    const endPoint = appConfig.backofficeEndpoint + `${APIPath.returnReport}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || '',
        'x-auth-mid': currentUser?.activeMerchant?.id || 0,
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = res.data
        const fileName = `รายงานการรับคืนสินค้า(ลดหนี้)`
        downloadCSVFile(reportData, fileName)
        setExporting(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onClickViewDetail = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  const renderActionButton = (text: string, record: ReturnData) => {
    if (record?.status !== ReturnStatus.DRAFT) return
    return (
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบข้อมูล"
        action="deleted"
        onClick={() => onClickDelete(record.id)}
      />
    )
  }

  const renderStatus = (status: string) => {
    const statusResult = getReturnOrderStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เลขที่สั่งซื้อ',
      dataIndex: 'order_no',
      key: 'order_no',
      width: '180px',
      render: (val: string, record: ReturnData) => (
        <LinkNo onClick={() => onClickViewDetail(record.id)}>{val}</LinkNo>
      ),
      sorter: true,
    },
    {
      title: 'ลูกค้า',
      dataIndex: 'customer_fullname',
      key: 'customer_fullname',
      sorter: true,
    },
    {
      title: 'ยอดเงินคืนสุทธิ',
      dataIndex: 'total_amount',
      key: 'total_amount',
      sorter: true,
      align: 'right',
      render: (val: number) => {
        return numberWithComma(val, true)
      },
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      width: '10px',
    },
    {
      title: 'ช่องทางการขาย',
      dataIndex: 'channel',
      key: 'channel',
      sorter: true,
      render: (channel: string) => getMenuTypeName(menuReturnChannel, channel || ''),
    },
    {
      title: 'วันที่รับคืนสินค้า',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (val: string) => formatDateTime(val || ''),
    },
    {
      title: 'ช่องทางการคืนเงิน',
      dataIndex: 'return_type',
      key: 'return_type',
      sorter: true,
      render: (return_type: string) => getMenuTypeName(menuReturnPaymentTypes, return_type || ''),
    },
    {
      title: 'สถานะการคืนเงิน',
      dataIndex: 'status',
      key: 'status',
      render: renderStatus,
      sorter: true,
    },
    // {
    //   title: 'รับคืนโดย',
    //   dataIndex: 'officer',
    //   key: 'officer',
    //   sorter: true,
    // },
    {
      width: '100px',
      title: '',
      key: 'action',
      align: 'center',
      render: renderActionButton,
    },
  ]

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const ConfirmDeleteModal = (
    <ConfirmDailog
      title={'ยืนยันการลบรายการรับคืนสินค้า'}
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const DetailDrawer = (
    <ReturnDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {
        onGetList()
      }}
      onPaymentSuccess={() => {}}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={24}>
          <Row gutter={[8, 8]}>
            <Col md={8} xs={24}>
              <SearchInput
                placeholder="ค้นหาเลขที่สั่งซื้อ,ชื่อลูกค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            {/* <Col xs={24} md={5}>
              <SelectItem
                name={'status'}
                label={''}
                isRequired={true}
                value={filter.status}
                placeHolder={'สถานะการคืนเงิน'}
                menu={menuReturnStatus}
                onChange={(val: any): void => onFilter('status', val)}
              />
            </Col> */}
            <Col xs={24} md={8}>
              <RangeDateItem
                placeHolder={['วันที่คืนเริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
            <Col>
              <PrimaryButton
                text="รายงานการรับคืนสินค้า(ลดหนี้)"
                btnType="Primary"
                onClick={onExport}
                icon={<DownloadOutlined />}
              />
            </Col>
          </Row>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const onChangeTab = (key: string) => {
    onFilter('status', key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const getTab = () => {
    return (
      <StickyHeader>
        <Tabs onChange={onChangeTab} activeKey={filter.status} type="line">
          {menuReturnStatus.map((item: any) => {
            return <TabPane tab={item.name} key={item.value}></TabPane>
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  return (
    <>
      <HomePageLayout selected="order-returns" title="รายการับคืนสินค้า" label="">
        <LoadingView isShow={exporting} />
        {getTab()}
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          onSort={(field: string, order: string) => {
            onSort(field, order)
          }}
          //scrollX={800}
        />
        {LoadingModal}
        {DetailDrawer}
        {ConfirmDeleteModal}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectReturnList(state),
    listEvent: selectReturnListEvent(state),
    event: selectReturnActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

export default connect(mapStateToProps)(OrderReturns)
